import React, { type ReactElement } from 'react';

import useTranslation from '@framework/hooks/useTranslation';

import FooterLink from './FooterLink/FooterLink';

import styles from './FooterLinks.module.scss';

const FooterLinks = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <ul className={styles.list}>
            <li className={styles.listItem}>
                <FooterLink link="https://www.sherpany.com/">Sherpany.com</FooterLink>
            </li>
            <li className={styles.listItem}>
                <FooterLink link="https://www.sherpany.com/resources/meeting-management/">
                    {t('Meeting resources')}
                </FooterLink>
            </li>
            <li className={styles.listItem}>
                <FooterLink link="https://www.sherpany.com/privacy-policy/">
                    {t('Privacy policy')}
                </FooterLink>
            </li>
            <li className={styles.listItem}>
                <FooterLink link="https://app.sherpany.com/terms/">{t('Terms of use')}</FooterLink>
            </li>
        </ul>
    );
};

export default FooterLinks;
